const FeaturesSection = () => {
  const features = [
    {
      icon: 'ri-heart-fill',
      title: '生後日数カウンター',
      description:
        '生まれてからの日数をひと目で確認。日数・月数・年数の切り替えも可能です',
      color: 'bg-primary',
    },
    {
      icon: 'ri-camera-fill',
      title: '思い出を残す',
      description:
        '写真とコメントで大切な瞬間を記録。日記とアルバムで思い出を整理',
      color: 'bg-secondary',
    },
    {
      icon: 'ri-line-chart-fill',
      title: '成長を見守る',
      description:
        '身長や体重の変化をグラフでわかりやすく表示。成長の軌跡を可視化',
      color: 'bg-accent-yellow',
    },
    {
      icon: 'ri-palette-fill',
      title: 'カスタマイズ自由',
      description:
        '背景色やフォント、表示ラベルなど、自分好みにカスタマイズ可能',
      color: 'bg-accent-green',
    },
  ];

  return (
    <section id="features" className="py-16 sm:py-20 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-block bg-accent-yellow px-4 py-2 rounded-full mb-4">
            <span className="text-text-primary text-sm font-medium">Features</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black font-maru text-text-primary mb-4 px-4">
            赤ちゃんダイアリーの機能
          </h2>
          <p className="text-base sm:text-lg text-text-secondary px-4">
            成長の記録を、もっと楽しく、もっと簡単に
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl p-6 sm:p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <div
                className={`w-16 h-16 sm:w-20 sm:h-20 ${feature.color} rounded-full flex items-center justify-center mb-5 sm:mb-6 mx-auto`}
              >
                <i className={`${feature.icon} text-white text-2xl sm:text-3xl`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold font-maru text-text-primary mb-2 sm:mb-3 text-center">
                {feature.title}
              </h3>
              <p className="text-sm text-text-secondary leading-relaxed text-center">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;